import {replace} from 'react-router-redux'
import {redirect} from '../core/react/router'
import {linkFinder} from '../core/links'
import {supportWebSocket} from '../core/browser'
import patrimonyRoutes, {patrimonyContactRoute} from '../patrimony/routes'
import {loadLinks as loadPatrimonyLinks, loadContactLinks as loadPatrimonyContactLinks} from '../patrimony/actions'
import ticketRoutes, {openTicketRoute} from '../ticket/routes'
import {loadLinks as loadTicketLinks} from '../ticket/actions'
import claimRoutes from '../claim/routes'
import {loadLinks as loadClaimLinks} from '../claim/actions'
import companyRoutes, {organisationRoute} from '../company/routes'
import {loadLinks as loadCompanyLinks} from '../company/actions'
import {loginRoute, activeUserRoute, forgotPasswordRoute, resetPasswordRoute, resetLoginRoute, accountRoute} from '../user/routes'
import {loadAuthenticatedUser} from '../user/actions'
import providerRoutes, {providerCoverageRoute, providerContactRoute, providerDirectoryRoute} from '../provider/routes'
import {loadProviderLinks, loadContactLinks as loadProviderContactLinks} from '../provider/actions'
import {todoRoute} from '../workflow/routes'
import {loadLinks as loadAppLinks, subscribeVersion} from './actions'
import App from './components/App'
import AuthLayout from './components/AuthLayout'
import UnauthLayout from './components/UnauthLayout'
import simplifiedRequestRoute from '../simplifiedRequest/routes'

function enterRoot(dispatch) {
    return dispatch(loadAuthenticatedUser()).then((authenticatedUserAction) => {
        const {user} = authenticatedUserAction

        if (user.userType == 'callCenterOperator' || user.userType == 'callCenterUser') {
            return dispatch(replace('/todolist'))
        }
        return dispatch(replace('/tickets'))
    })
}

function enterAuth(dispatch) {
    return Promise.all([
        dispatch(loadAppLinks()),
        dispatch(loadAuthenticatedUser()),
        supportWebSocket() && dispatch(subscribeVersion())
    ]).then(([appLinksAction]) => {
        const _appLinks = appLinksAction._links

        return Promise.all([
            _appLinks.find(linkFinder('tickets')) && dispatch(loadTicketLinks()),
            _appLinks.find(linkFinder('ticketclaims')) && dispatch(loadClaimLinks()),
            _appLinks.find(linkFinder('clientcompanies')) && dispatch(loadCompanyLinks()),
            _appLinks.find(linkFinder('patrimonies')) && dispatch(loadPatrimonyLinks()),
            _appLinks.find(linkFinder('providercompanies')) && dispatch(loadProviderLinks()),
            _appLinks.find(linkFinder('providercontacts')) && dispatch(loadProviderContactLinks()),
            _appLinks.find(linkFinder('patrimonycontacts')) && dispatch(loadPatrimonyContactLinks())
        ])
    })
}

function enterUnauth(dispatch) {
    return Promise.all([
        dispatch(loadAppLinks()),
        supportWebSocket() && dispatch(subscribeVersion())
    ]).then(([appLinksAction]) => {
        const _appLinks = appLinksAction._links

        return Promise.all([
            _appLinks.find(linkFinder('tickets')) && dispatch(loadTicketLinks()),
            _appLinks.find(linkFinder('ticketclaims')) && dispatch(loadClaimLinks()),
            _appLinks.find(linkFinder('clientcompanies')) && dispatch(loadCompanyLinks()),
            _appLinks.find(linkFinder('patrimonies')) && dispatch(loadPatrimonyLinks()),
            _appLinks.find(linkFinder('providercompanies')) && dispatch(loadProviderLinks()),
            _appLinks.find(linkFinder('providercontacts')) && dispatch(loadProviderContactLinks()),
            _appLinks.find(linkFinder('patrimonycontacts')) && dispatch(loadPatrimonyContactLinks())
        ])
    })
}

export default function(dispatcher, store) {
    return [{
        path: '/',
        component: App,
        indexRoute: {
            onEnter: dispatcher(enterRoot)
        },
        childRoutes: [{
            component: AuthLayout,
            onEnter: dispatcher(enterAuth),
            childRoutes: [
                patrimonyRoutes('/patrimonies', dispatcher, store),
                patrimonyContactRoute('/patrimonycontacts', dispatcher, store),
                ticketRoutes('/tickets', dispatcher, store),
                claimRoutes('/claims', dispatcher, store),
                companyRoutes('/companies', dispatcher, store),
                organisationRoute('/organisations', dispatcher, store),
                providerRoutes('/providers', dispatcher, store),
                providerCoverageRoute('/providercoverage', dispatcher, store),
                providerContactRoute('/providercontacts', dispatcher, store),
                providerDirectoryRoute('/providerdirectory', dispatcher, store),
                accountRoute('/account', dispatcher, store),
                todoRoute('/todolist', dispatcher, store),
                openTicketRoute('/openticket', dispatcher, store),
                simplifiedRequestRoute(dispatcher, store)
	        ]
	    }, {
            component: UnauthLayout,
            onEnter: dispatcher(enterUnauth),
            childRoutes: [
                loginRoute('/login', dispatcher, store),
                activeUserRoute('/aciveuseraccount', dispatcher, store),
                forgotPasswordRoute('/forgotpassword', dispatcher, store),
                resetPasswordRoute('/resetpassword', dispatcher, store),
                resetLoginRoute('/resetlogin', dispatcher, store)
            ]
	    }]
    }, {
        path: '*',
        onEnter: redirect('/')
    }]
}


// WEBPACK FOOTER //
// ./lib/app/routes.js